import React from 'react';
import {
  Button as ButtonEms,
  FilterRow,
  Icons,
  isCompletedTimeFormat,
  isValidTime,
  onCloseTimeDialogValidation,
  RangeSelector,
  validateTimeFormat,
} from '@ems/client-design-system';
import { Filter, IDFilter } from 'src/componentsMigrated';
import {
  FilterComponentTypes,
  IdFilterProps,
  SelectionFilterFilterProps,
  TimeFilterProps,
  FilterBySelectedProps
} from 'src/@operations/containers/FilterContainer/filters.types';
import { useOperationsFilter } from './useOperationsFilter';
import { Menu, MenuItem } from '@blueprintjs/core-modern';
import { useDataSelectors } from 'src/@operations/reducers';
import { FilterPopover } from 'src/componentsModern';

export const OperationsFilterContainer = () => {
  const {
    filters,
    clearAllFilters,
    filterRowLanguageData,
    isClearFiltersDisabled,
    pcaData: { pcaLocation, pcaFieldLabel, onClearPcaFilter },

  } = useOperationsFilter();

  const dataSelectors = useDataSelectors();
  const {
    selectedInTable,
    selectedInTableHistory,
  } = dataSelectors.getDataInformation();

  const filterComponents = filters.flatMap(({ filterType, filterCategory, filterProps }) => {
    switch (filterType) {
      case FilterComponentTypes.Selection: {
        const {
          filterItems,
          selectedItems,
          onUpdateFilter,
          iconCategories,
          theme,
          categoryLabel,
          languageData,
          selectMultiple = true,
        } = filterProps as SelectionFilterFilterProps;
        return (
          <Filter
            key={filterCategory}
            categoryName={categoryLabel}
            filterItems={filterItems}
            selectedItems={selectedItems}
            updateItems={onUpdateFilter}
            languageData={languageData}
            iconCategories={iconCategories}
            theme={theme}
            type={selectMultiple ? 'multiple' : 'single'}
            showSelectAll={selectMultiple}
          />
        );
      }
      case FilterComponentTypes.ID: {
        const {
          onFilterChange,
          onFilterSubmit,
          onFilterClear,
          selectedItems,
          searchValue,
          languageData,
          categoryLabel,
        } = filterProps as IdFilterProps;
        return (
          <IDFilter
            categoryName={categoryLabel}
            key={`filter-id-${filterCategory}`}
            value={searchValue}
            onChange={onFilterChange}
            onSubmit={onFilterSubmit}
            selectedID={selectedItems}
            onClearSelect={onFilterClear}
            languageData={languageData}
          />
        );
      }
      case FilterComponentTypes.Time: {
        const { filterValues, setInputValue, label, languageData } = filterProps as TimeFilterProps;
        return (
          <RangeSelector
            key="filter-time-selector"
            type="time"
            min={null}
            max={null}
            fromInputValue={filterValues.from}
            toInputValue={filterValues.to}
            setInputValue={setInputValue}
            label={label}
            validateInputFormat={validateTimeFormat}
            isValidValue={isValidTime}
            onCloseValidation={onCloseTimeDialogValidation}
            isCompletedValueFormat={isCompletedTimeFormat}
            languageData={languageData}
          />
        );
      }
      case FilterComponentTypes.FilterBySelected: {

        const { onFilterBySelected, onFilterBySelectedBack, onClearFilterBySelected, languageData } = filterProps as FilterBySelectedProps;
        return (
          <FilterPopover
            activateText={languageData.filterBySelected}
            content={
              <Menu>
                <MenuItem text={languageData.filterBySelected} onClick={() => onFilterBySelected(selectedInTable)} disabled={selectedInTable.length === 0} />
                <MenuItem text={languageData.filterBySelectedPrevious} onClick={() => onFilterBySelectedBack(selectedInTableHistory)} disabled={selectedInTableHistory.length < 1} />
                <MenuItem text={languageData.filterBySelectedClear} onClick={() => onClearFilterBySelected()} disabled={selectedInTableHistory.length < 1} />
              </Menu>
            }
          />
        );
      }
      default:
        console.warn(`${filterType} component has not been configured for operations filter`);
        return [];
    }
  });

  if (pcaLocation) {
    filterComponents.push(
      <span className="filter-pca-location" key="filter-pca">
        <span className="filter-pca-location--category">{pcaFieldLabel}: </span>
        <span className="filter-pca-location--item">{pcaLocation}</span>
        <ButtonEms
          style="subtle"
          leftIcon={<Icons iconName="ic-ui-cancel-sm" />}
          onClick={onClearPcaFilter}
        />
      </span>
    );
  }

  return (
    <FilterRow
      filters={filterComponents}
      clearFilters={clearAllFilters}
      clearDisabled={isClearFiltersDisabled}
      languageData={filterRowLanguageData}
    />
  );
};
